export default {
    todosAjustes: {
        paginacao: {
            page: 1,
            rowsPerPage: 10,
            sortDesc: [false],
            sortBy: ['codigo']
        },
        filtros: {
            conteudo: {
                value: null,
                default: null,
                label: 'Pesquisa'
            }
        }
    },
    ajuste: {}
}
